import type { ReactNode } from "react";

/**
 * The app's one scroll container. Anything that has to measure against the
 * screen — the map's expansion, an overlay pinned to the frame — finds it
 * with this rather than walking up the tree guessing.
 */
export const SCREEN_SCROLLER = '[data-scroll-restoration-id="screen"]';

/**
 * A layer covering the screen exactly, and nothing above it.
 *
 * Fixed rather than laid out in the page, so where a screen renders it makes
 * no difference — a dialog written at the foot of a page is still a dialog.
 * The screen's frame contains paint, which makes it the containing block for
 * anything fixed inside it, so this takes the screen's edges without
 * measuring them and keeps them as those edges move.
 *
 * On a phone its panel is a sheet: full width, sitting on the bottom edge and
 * rising from it (`shell.css`). `sheet={false}` is for a panel that fills the
 * screen anyway.
 */
export function ScreenOverlay({
  children,
  sheet = true,
}: {
  children: ReactNode;
  sheet?: boolean;
}) {
  return (
    <div
      data-sheet={sheet || undefined}
      className="screen-overlay fixed inset-0 z-40 flex items-center justify-center app-screen-top-corners overflow-hidden p-6"
    >
      {children}
    </div>
  );
}
